import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import { flashcardPreviewClass } from './FlashcardStack';
import { twMerge } from 'tailwind-merge';

type FrontFlashcardProps = { content: string };

export function FrontFlashcard({ content }: FrontFlashcardProps) {
  return (
    <HtmlPreview
      format="default"
      html={content}
      className={twMerge(flashcardPreviewClass, '[&_p]:text-2xl')}
    />
  );
}
